var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errPage-container"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("你没有权限去该页面")]),_c('h6',[_vm._v("如有需要请联系你领导")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }